import React, { forwardRef } from 'react';
import { FormDocument, PAGE_SIZE_PX } from '../store/types';
import ElementRenderer from '../Canvas/ElementRenderer';

interface Props {
  document: FormDocument;
}

const noop = () => {};

const PrintPreview = forwardRef<HTMLDivElement, Props>(({ document: doc }, ref) => {
  const base = PAGE_SIZE_PX[doc.pageSize];
  const pageWidth = doc.orientation === 'landscape' ? base.height : base.width;
  const pageHeight = doc.orientation === 'landscape' ? base.width : base.height;

  return (
    <div ref={ref} className="fd-print-preview">
      {doc.pages.map((page, i) => (
        <div
          key={page.id}
          className="fd-print-page"
          style={{
            position: 'relative',
            width: pageWidth,
            height: pageHeight,
            background: '#fff',
            margin: '0 auto',
            pageBreakAfter: i < doc.pages.length - 1 ? 'always' : 'auto',
            overflow: 'hidden',
          }}
        >
          {page.elements
            .filter((el) => el.visible)
            .map((el) => (
              <ElementRenderer key={el.id} element={el} isSelected={false} onMouseDown={noop} />
            ))}
        </div>
      ))}
    </div>
  );
});

PrintPreview.displayName = 'PrintPreview';

export default PrintPreview;
